const INTERNAL_DOMAIN_CODE = /\b[A-Z]{1,4}\d{1,4}-C\d{1,4}\b/iu;
const UUID = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/giu;
const WAVE_SUFFIX = /\s*[—–-]\s*موج\s*[۰-۹0-9]+\s*$/u;
const LEADING_DECORATION = /^[\s🔔📌]+/u;

export function publicTaskTitle(value: unknown): string {
  const source = typeof value === "string" ? value.trim() : "";
  if (!source) return "کار سالن";

  let visible = source.replace(LEADING_DECORATION, "").trim();
  const internalCodeIndex = visible.search(INTERNAL_DOMAIN_CODE);
  if (internalCodeIndex >= 0) {
    visible = visible.slice(0, internalCodeIndex);
  }

  visible = visible
    .replace(UUID, "")
    .replace(WAVE_SUFFIX, "")
    .replace(/\s*[—–-]\s*$/u, "")
    .replace(/\s{2,}/gu, " ")
    .trim();

  return visible || "کار سالن";
}
